var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 374.816 117.176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 3634",
    filter: "url(#filter0_f_0_149)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.408,
    cy: 58.588,
    rx: 146.408,
    ry: 17.588,
    fill: "var(--fill-0, #C1B1FF)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_149",
    x: 0,
    y: 0,
    width: 374.816,
    height: 117.176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.5,
    result: "effect1_foregroundBlur_0_149"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponGlow);
export default __webpack_public_path__ + "static/media/coupon-glow.48642b0b1e87442b722de8c473a15ea2.svg";
export { ForwardRef as ReactComponent };